<!-- NAVBAR -->
<nav>
  <a routerLink="/" class="nav-brand">
    <img class="nav-logo" src="assets/logo-rogledi.svg" alt="Rogledi" width="36" height="36">
    <span class="nav-name">Rogledi</span>
  </a>
  <div class="nav-links">
    <a routerLink="/" class="nav-link">← Home</a>
    <a href="#contatti" class="nav-link">✉️ Contatti</a>
  </div>
</nav>

<!-- HERO -->
<div class="hero">
  <div class="hero-eyebrow"><span></span> Gestionale su misura · TRMNL Integration</div>
  <h1>Display e-ink<br><em>gestiti con semplicità</em></h1>
  <p class="hero-sub">Configuriamo, distribuiamo e monitoriamo lavagnette TRMNL per istituzioni e aziende. Un pannello unico per controllare ogni dispositivo.</p>
  <div class="hero-ctas">
    <a href="#contatti" class="btn-primary">Contattaci</a>
    <a href="#funzionalita" class="btn-ghost">Scopri di più</a>
  </div>
  <!-- Le tre lavagnette dell'hero: stesse cornici e stessa carta e-ink della
       home, così chi arriva qui dalla card riconosce subito lo stesso oggetto. -->
  <div class="hero-card-wrap">
    <div class="hero-card">
      <div class="eink-device">
        <div class="eink-screen">
          <div class="eink-head"><span>Aula 522</span><span class="eink-batt"><span class="eink-wifi"></span>82%</span></div>
          <div class="eink-now busy">IN CORSO</div>
          <div class="eink-line strong">Diritto Privato</div>
          <div class="eink-line">09:00 – 11:00 · Prof. Conti</div>
          <div class="eink-foot">Aggiornato 1 min fa</div>
        </div>
        <div class="eink-brand">TRMNL</div>
      </div>

      <div class="eink-device">
        <div class="eink-screen">
          <div class="eink-head"><span>Aula 316</span><span class="eink-batt"><span class="eink-wifi"></span>64%</span></div>
          <div class="eink-now busy">OCCUPATA</div>
          <div class="eink-line strong">Marketing Digitale</div>
          <div class="eink-line">11:30 – 13:00 · Prof. Neri</div>
          <div class="eink-foot">Aggiornato 3 min fa</div>
        </div>
        <div class="eink-brand">TRMNL</div>
      </div>

      <div class="eink-device">
        <div class="eink-screen">
          <div class="eink-head"><span>Aula 108</span><span class="eink-batt"><span class="eink-wifi"></span>91%</span></div>
          <div class="eink-now free">LIBERA</div>
          <div class="eink-line strong">Prossima alle 15:00</div>
          <div class="eink-line">Laboratorio di Editoria</div>
          <div class="eink-foot">Aggiornato ora</div>
        </div>
        <div class="eink-brand">TRMNL</div>
      </div>
    </div>
  </div>
</div>

<!-- FEATURES -->
<section id="funzionalita">
  <div class="container">
    <div class="section-eyebrow">Funzionalità</div>
    <h2 class="section-title">Tutto quello che ti serve,<br>in un unico pannello</h2>
    <p class="section-sub">Dall'aggiunta di un dispositivo alla personalizzazione dei template, ogni aspetto è gestibile senza competenze tecniche.</p>
    <div class="features-grid">
      <div class="feature-card">
        <div class="feature-icon g-info">📡</div>
        <h3>Registrazione device</h3>
        <p>Aggiungi nuove lavagnette in pochi secondi. Ogni dispositivo si registra automaticamente al primo avvio.</p>
      </div>
      <div class="feature-card">
        <div class="feature-icon g-primary">🎨</div>
        <h3>Template Liquid</h3>
        <p>Personalizza il layout visivo con template HTML/Liquid. Pieno controllo sulla grafica senza toccare il codice PHP.</p>
      </div>
      <div class="feature-card">
        <div class="feature-icon g-success">🗓️</div>
        <h3>Sincronizzazione eventi</h3>
        <p>Gli eventi vengono aggiornati automaticamente dall'API del gestionale aule. Nessuna operazione manuale.</p>
      </div>
      <div class="feature-card">
        <div class="feature-icon g-warning">🔋</div>
        <h3>Monitoring in tempo reale</h3>
        <p>Batteria, segnale Wi-Fi, versione firmware: ogni parametro è monitorato e visibile nel pannello di controllo.</p>
      </div>
    </div>
  </div>
</section>

<!-- TRMNL SECTION -->
<div class="trmnl-section">
  <div class="trmnl-inner">
    <div class="trmnl-visual">
      <div class="eink-scene">
        <div class="eink-device back">
          <div class="eink-screen">
            <div class="eink-head"><span>Sala riunioni</span><span class="eink-batt">91%</span></div>
            <div class="eink-now free">LIBERA</div>
            <div class="eink-line strong">Prossima alle 15:00</div>
            <div class="eink-line">Consiglio di corso</div>
          </div>
          <div class="eink-brand">TRMNL</div>
        </div>

        <div class="eink-device main">
          <div class="eink-screen">
            <div class="eink-head">
              <span>Aula 522 · Oggi</span>
              <span class="eink-batt"><span class="eink-wifi"></span>78%</span>
            </div>
            <div class="eink-now busy">IN CORSO</div>
            <div class="eink-line strong">Sociologia della Comunicazione</div>
            <div class="eink-line">09:00 – 11:00 · Prof. Rossi</div>
            <div class="eink-rule"></div>
            <div class="eink-label">Prossimo</div>
            <div class="eink-line strong">Linguistica Applicata</div>
            <div class="eink-line">14:00 – 16:00 · Prof. Bianchi</div>
            <div class="eink-foot">Aggiornato 2 min fa</div>
          </div>
          <div class="eink-brand">TRMNL</div>
        </div>
      </div>
    </div>
    <div class="trmnl-content">
      <div class="section-eyebrow">Integrazione TRMNL</div>
      <h2 class="section-title">Gestionali su misura per display e-ink</h2>
      <p class="section-sub">TRMNL è una piattaforma hardware e software che trasforma piccole lavagnette e-ink in display informativi sempre aggiornati. Noi costruiamo il backend su misura per la tua realtà.</p>
      <div class="trmnl-list">
        <div class="trmnl-item">
          <div class="trmnl-item-icon g-info">🔄</div>
          <div class="trmnl-item-text">
            <h4>Aggiornamento autonomo</h4>
            <p>Ogni lavagnetta calcola in autonomia il prossimo intervallo di poll in base agli eventi in programma.</p>
          </div>
        </div>
        <div class="trmnl-item">
          <div class="trmnl-item-icon g-success">🧩</div>
          <div class="trmnl-item-text">
            <h4>Template Liquid</h4>
            <p>Il display mostra sempre il template liquid adattato alla dimensione o al tipo di device.</p>
          </div>
        </div>
        <div class="trmnl-item">
          <div class="trmnl-item-icon g-primary">⚡</div>
          <div class="trmnl-item-text">
            <h4>Zero manutenzione</h4>
            <p>Una volta configurato, il sistema gira da solo. Il pannello admin serve solo per monitorare e personalizzare.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- STATS -->
<section class="stats-section">
  <div class="container">
    <div class="stats-header">
      <div class="section-eyebrow">In numeri</div>
      <h2 class="section-title">Una piattaforma affidabile</h2>
    </div>
    <div class="stats-grid">
      <div class="stat-card">
        <div class="stat-num">800×480</div>
        <div class="stat-label">Pixel di risoluzione del display e-ink</div>
      </div>
      <div class="stat-card">
        <div class="stat-num">100%</div>
        <div class="stat-label">Personalizzazione con template Liquid</div>
      </div>
      <div class="stat-card">
        <div class="stat-num">Mesi</div>
        <div class="stat-label">Autonomia della batteria con una sola ricarica</div>
      </div>
      <div class="stat-card">
        <div class="stat-num">60s</div>
        <div class="stat-label">Dal primo avvio al display operativo</div>
      </div>
    </div>
  </div>
</section>

<!-- CONTATTI -->
<div class="cta-section" id="contatti">
  <h2>Contattaci per informazioni o proposte.</h2>
  <p>Inviaci un messaggio per una demo su misura.</p>

  <form class="contact-form" (submit)="sendContact($event)">
    <!-- honeypot: nascosto agli umani, compilato dai bot -->
    <input name="website" autocomplete="off" tabindex="-1" aria-hidden="true" style="position:absolute;left:-9999px;width:1px;height:1px;overflow:hidden" />
    <input    [(ngModel)]="contactName"  name="name"    placeholder="Il tuo nome"      maxlength="100"  required />
    <input    [(ngModel)]="contactPhone" name="phone"   placeholder="Telefono (facoltativo)" maxlength="30" type="tel" />
    <textarea [(ngModel)]="contactMsg"   name="message" placeholder="Il tuo messaggio" maxlength="2000" rows="4" required></textarea>
    <div class="contact-footer">
      @if (contactStatus === 'ok') {
        <span class="contact-ok">✦ Messaggio inviato! Ti ricontatteremo presto.</span>
      } @else if (contactStatus === 'error') {
        <span class="contact-err">✗ Errore nell'invio, riprova.</span>
      }
      <button type="submit" [disabled]="contactSending">
        {{ contactSending ? 'Invio in corso…' : 'Invia messaggio' }}
      </button>
    </div>
  </form>
</div>

<!-- FOOTER -->
<footer>
  <span>© 2026 Rogledi · Gestionale TRMNL su misura</span>
  <div class="footer-links">
    <a routerLink="/">Home</a>
    <a href="#contatti">Contatti</a>
    <a routerLink="/privacy">Privacy Policy</a>
  </div>
</footer>
